import { useRef, useState } from 'react';
import { providerCommandKeys } from '@/lib/provider-command-keys';

export function useGrowthCommand() {
  const keyFor = useRef(providerCommandKeys());
  const pending = useRef(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  async function run<T>(action: string, payload: unknown, perform: (key: string) => Promise<T>): Promise<T | undefined> {
    if (pending.current) return;
    pending.current = true;
    setBusy(true); setError(''); setMessage('');
    try {
      return await perform(keyFor.current(action, payload));
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : 'The request failed. Your edits are kept.');
    } finally {
      pending.current = false; setBusy(false);
    }
  }
  return { busy, error, message, setMessage, run };
}
